import { Box, Center, HStack, Stack, Text } from '@chakra-ui/react'
import MirohaLogo from 'src/assets/image/miroha-logo.svg'
import SorryDr from 'src/assets/image/sorry-dr.svg'

export const NotFound: React.FC = () => {
  return (
    <Center w="full" h="100svh" color="gray.400" p="0">
      <Box position="fixed" left="4" top="4">
        <img src={MirohaLogo} alt="MiROHA Logo" />
      </Box>
      <Stack spacing="6" p="4">
        <HStack>
          <Text
            fontSize={{ base: '56px', md: '72', lg: '96px' }}
            fontWeight="bold"
            wordBreak="keep-all"
          >
            Sorry...
          </Text>
          <img src={SorryDr} alt="Sorry Dr." />
        </HStack>
        <Stack spacing="4">
          <Text
            fontSize={{ base: '16px', md: '24px', lg: '32px' }}
            fontWeight="bold"
          >
            お探しのページが見つかりませんでした。
          </Text>
          <Text fontSize={{ base: '10px', md: '14px', lg: '20px' }}>
            ページは削除、変更されたか現在利用できない可能性があります。
          </Text>
        </Stack>
      </Stack>
    </Center>
  )
}
